// 부모(FE)가 postMessage 로 주입하는 인증 토큰을 "가능한 한 빨리" 잡아 캐시한다.
// 이 모듈은 main.ts 최상단에서 import 되어, 게임 선택(GET /games/active fetch)이나
// 게임 번들 동적 import 전에 리스너가 등록된다 → fetch 대기 중 도착하는 토큰도 놓치지 않음.
//
// 허용 origin 외 메시지는 무시(XSS/위장 차단). '/' 가 dev 에서 다른 게임으로 교체돼도
// FE 무수정 동작하도록 두 auth type 모두 수용.

const ALLOWED_PARENT_ORIGINS: ReadonlySet<string> = new Set([
  'https://me.bloomingo.team',
  'https://dev.bloomingo.team',
  'http://localhost:3000',
]);

const ACCEPTED_AUTH_TYPES: ReadonlySet<string> = new Set([
  'bloomy-runner:auth',
  'poop-dodge:auth',
]);

let currentToken: string | null = null;
const subscribers: Array<(token: string) => void> = [];
const waiters: Array<() => void> = [];

if (typeof window !== 'undefined') {
  window.addEventListener('message', (event: MessageEvent) => {
    if (!ALLOWED_PARENT_ORIGINS.has(event.origin)) return;
    const data = event.data as { type?: unknown; accessToken?: unknown } | null;
    if (
      typeof data !== 'object' ||
      data === null ||
      typeof data.type !== 'string' ||
      !ACCEPTED_AUTH_TYPES.has(data.type) ||
      typeof data.accessToken !== 'string'
    )
      return;
    currentToken = data.accessToken;
    for (const cb of subscribers) cb(currentToken);
    while (waiters.length > 0) waiters.shift()?.();
  });
}

export function getAuthToken(): string | null {
  return currentToken;
}

// 토큰이 들어올 때마다 콜백 호출(만료/갱신 재주입). 이미 잡혀 있으면 즉시 1회 호출.
export function onAuthToken(callback: (token: string) => void): void {
  subscribers.push(callback);
  if (currentToken !== null) callback(currentToken);
}

// 첫 토큰 도착까지 대기. 이미 있으면 즉시 resolve, timeout 후에도 resolve(폴백).
export function waitForAuthToken(timeoutMs: number): Promise<void> {
  if (currentToken !== null) return Promise.resolve();
  return new Promise((resolve) => {
    waiters.push(resolve);
    setTimeout(resolve, timeoutMs);
  });
}
